import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/outline';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import swal from 'sweetalert';
import { PlusIcon } from '@heroicons/react/solid';
import LoadingBar from 'react-top-loading-bar';
import { useIsOnline } from 'react-use-is-online';
import { useGetSytemPurposesOfTravelQuery } from '../../Features/purposeOfTravelSlice';


function ManagePurposeOfTravelView({}) {
    const navigate = useNavigate();
    const [progress, setProgress] = useState(0);
    const { isOnline } = useIsOnline();
    const [currentItems, setCurrentItems] = useState([]);

    const {
      data: data,
      isLoading,
      isSuccess,
      isError,
      error
    } = useGetSytemPurposesOfTravelQuery()

    const [input, setInput] = useState({
      search: ''
    })

    useEffect(()=>{
    setProgress(30)
        if(isLoading){
            setProgress(80)
        }
        if(isSuccess && !currentItems.length > 0){
          setCurrentItems(data.data);
        }
        setProgress(100)
        return () =>{
        }
    },[data])

  const edit = (e, id)=>{
    if(!isOnline){
      return swal("No Internet connection",'Please check Internet connection and try again'); 
    }
    navigate("/user/edit-purpose/"+id)
  }

    const trancateText = (str)=>{
      return str.length > 25 ? str.substring(0, 25) + "..." : str;
    }
    
    return (
      <div className="flex md:w-2/4 mb-12">
        <LoadingBar
        color="#14b8a6"
        height="4px"
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
        />
      <div className='bg-white shadow-md rounded-md'>
        {(isSuccess)?
          <div className="md:flex items-center md:justify-between px-4 py-6 space-y-4">
            <Link to='/user/create-purpose' className='flex items-center text-sm text-white justify-center bg-green-400 px-3 py-2 rounded-sm hover:shadow-md cursor-pointer'>
              <PlusIcon className='h-4 w-4'></PlusIcon>
              <div className=''>ADD PURPOSE</div>
            </Link>
          </div>
          : null
        }
        {
              (currentItems.length > 0)?
                <table className="table-fixed w-full divide-y divide-gray-100">
                  <thead className="text-xs text-gray-500">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left font-medium tracking-wider"
                      >
                        Purpose
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    { currentItems.map(data => (
                      <tr onClick={(e)=>edit(e,data.id)} key={data.id} className="hover:bg-gray-50 cursor-pointer text-gray-700 text-xs">
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="flex items-center">
                            <div className="">
                                <div className="flex items-center">
                                    <div className="">{trancateText(data.purpose)}</div>
                                </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                }
                  </tbody>
                </table>
              : isError?
                  <Link to='/user/create-purpose' className='flex items-center text-sm text-white justify-center bg-green-400 px-3 py-2 rounded-sm hover:shadow-md cursor-pointer'>
                    <PlusIcon className='h-4 w-4'></PlusIcon>
                    <div className=''>ADD PURPOSE</div>
                  </Link>
              : null
            }
        </div>
      </div>
    )
}

export default ManagePurposeOfTravelView;
